import { QCONTENT_DETAILS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { useQContent } from '@exam-management/common/qcontent-provider';
import { NavigateBackLinkWithHistory, QContentStatusTag } from '@exam-management/components';
import { useQBankStructure } from '@exam-management/qbs-provider';
import {
  SingleQuestionNavigationTabs,
  type QContentDetailFormContextData,
} from '@exam-management/qcontent-management';
import { CopyToClipboard, EllipsisText, Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { SingleQuestionHeaderMenu } from '../single-question-header-menu';

interface SingleQuestionHeaderProps {
  handleSave: (data: QContentDetailFormContextData) => Promise<string | null | undefined>;
  structureId: string;
}

export default function SingleQuestionHeader(props: Readonly<SingleQuestionHeaderProps>) {
  const { structureId, handleSave } = props;

  const { qBankStructureInformation } = useQBankStructure();
  const { code, name } = qBankStructureInformation;

  const { qContent } = useQContent();
  const { refCode, updatedAt, status, refQuestion } = qContent;

  return (
    <PageHeader
      title={refCode}
      linkAdornment={
        <NavigateBackLinkWithHistory
          fallbackPath='/qbank-structures/:structureId/qcontents'
          matchPatterns='/qbank-structures/:structureId/qcontents'
          fallbackParams={{ structureId }}
          label='Back'
        />
      }
      tabs={<SingleQuestionNavigationTabs questionStatus={status} />}
      endAdornment={
        <>
          <QContentStatusTag
            data-testid={QCONTENT_DETAILS_DATA_TEST_ID.STATUS_TAG}
            status={status}
            size='large'
          />
          <SingleQuestionHeaderMenu handleSave={handleSave} status={status} />
        </>
      }
      subtitleSection={
        <>
          <Flex sx={{ gap: (theme) => theme.spacing(4), alignItems: 'center' }}>
            <EllipsisText variant='body2' maxLines={2}>{`CourseID: ${code}`}</EllipsisText>
            <EllipsisText variant='body2' maxLines={2}>
              {name}
            </EllipsisText>
            <Text variant='body2'>
              Q Ref:{' '}
              {refQuestion?.id ? (
                <CopyToClipboard as='span' text={refQuestion?.refCode ?? '-'}>
                  {refQuestion?.refCode ?? '-'}
                </CopyToClipboard>
              ) : (
                '-'
              )}
            </Text>
          </Flex>
          <Text color='text.secondary' variant='body2'>
            Last Modified: {formatDateTime(updatedAt)}
          </Text>
        </>
      }
    />
  );
}
